export const formatkWhEnergy = (energy: number) => {
  const formatValue = (value: number) =>
    new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 1,
    }).format(value);

  if (energy < 1000) {
    return `${formatValue(energy)}kWh`;
  }
  if (energy < 1000000) {
    return `${formatValue(energy / 1000)}MWh`;
  }

  return `${formatValue(energy / 1000000)}GWh`;
};
